// Live arcade progress for a person, replayed from the local event log.
import { useLiveQuery } from 'dexie-react-hooks'
import { useMemo } from 'react'
import { emptyProgress, project, type Progress } from '../domain/arcade/progress'
import { playsOf } from '../domain/players'
import { inTrip } from '../domain/tripScope'
import { db } from './db'
import { usePack } from './pack'
import { useSession } from './session'

/** The log as this trip sees it: learning and family events, plus this trip's own (domain/tripScope). */
export function useEvents() {
  const all = useLiveQuery(() => db.events.toArray(), [], [])
  const active = usePack((s) => s.pack?.meta.id)
  const first = usePack((s) => s.firstTrip)
  return useMemo(() => (active ? all.filter((e) => inTrip(e, active, first ?? active)) : all), [all, active, first])
}

export function useProgress(personId: string | undefined): Progress {
  const events = useEvents()
  return useMemo(() => (personId ? project(events, personId) : emptyProgress()), [events, personId])
}

/** The player whose progress the Map is about: the signed-in player, or (for a grown-up who doesn't play) the first player. */
export function usePlayerId(): string | undefined {
  const { person, people } = useSession()
  if (person && playsOf(person)) return person.id
  return people?.find(playsOf)?.id
}
